import { PersonalAccount } from '@src/components/PersonalAccaunt/PersonalAccount'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@src/store/store'
import { getAccounts } from '@src/store/ducks/user/thunks'
import useQuery from '@src/hooks/useQuery'
import { fetchMe } from '@src/store/ducks/app/thunks'
import style from './Account.module.scss'

export const Account = () => {
  const dispatch = useDispatch<AppDispatch>()
  const token = useQuery('token')
  const noPay = useQuery('no-pay')

  useEffect(() => {
    if (token) {
      sessionStorage.setItem('token', token)
      dispatch(fetchMe())
      dispatch(getAccounts())
    }
  }, [dispatch, token])

  return (
    <div className={style.container}>
      <div className="content">
        <PersonalAccount noPay={noPay === '1'} />
      </div>
    </div>
  )
}
